import App from './App.svelte';
import '../public/global.css';

export default new App({ target: document.body });
